import Excel from "exceljs";

export default async function exportProductsXlsx(supplierName, products) {
  const workbook = new Excel.Workbook();
  const sheet = workbook.addWorksheet("Products", {
    views: [{ state: "frozen", ySplit: 1, showGridLines: false }],
  });
  sheet.columns = [
    { header: "Product Number\n产品编号", key: "number", width: 24 },
    { header: "Product Name\n产品英文名", key: "name", width: 52 },
    { header: "Product Name CN\n产品中文名", key: "nameCn", width: 40 },
    { header: "fcst_qty\n预测库存数量", key: "fcst_qty", width: 18 },
  ];
  products.forEach((product) => {
    const quantity = Number(product.fcst_qty);
    sheet.addRow({
      number: String(product.number ?? ""),
      name: product.name ?? "",
      nameCn: product.nameCn ?? "",
      fcst_qty:
        product.fcst_qty === null || product.fcst_qty === undefined
          ? null
          : Number.isFinite(quantity)
            ? quantity
            : 0,
    });
  });
  sheet.eachRow((row, rowNumber) => {
    const isHeader = rowNumber === 1;
    row.height = isHeader ? 42 : 40;
    row.eachCell({ includeEmpty: true }, (cell, column) => {
      cell.font = {
        name: "Helvetica Neue",
        size: 11,
        bold: isHeader,
        color: { argb: isHeader ? "FF6E6E73" : "FF1D1D1F" },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: column === 4 ? "right" : "left",
        wrapText: isHeader || column === 2 || column === 3,
        indent: 1,
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: isHeader
            ? "FFF5F5F7"
            : rowNumber % 2 === 0
              ? "FFFFFFFF"
              : "FFFAFAFC",
        },
      };
      cell.border = {
        bottom: { style: "hair", color: { argb: "FFE5E5EA" } },
      };
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const url = window.URL.createObjectURL(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
  );
  const link = document.createElement("a");
  try {
    const safeSupplierName = String(supplierName).replace(/[<>:"/\\|?*]/g, "-");
    link.href = url;
    link.download = `${safeSupplierName} - Stock Products - ${new Date().toISOString().slice(0, 10)}.xlsx`;
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
